import styled from 'styled-components'

import colors from './colors'

const YellowWell = styled.div`
  padding: 1rem;
  background: ${colors.lightYellow};
  color: ${colors.orange};
`

const GrayWell = styled.ul`
  background: ${colors.lightGray};
  margin: 0 0 1rem;
  padding: 1rem 2rem;
  border-radius: .5rem;

  li {
    color: ${colors.secondaryText};
    font-size: .9rem;
    margin: 0 0 .5rem;
    text-decoration: none;

    &:last-child {
      margin: 0;
    }
  }
`

export {
  YellowWell,
  GrayWell,
}



// WEBPACK FOOTER //
// ./src/styles/wells.js